import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Services = () => {
  const servicesList = [
    {
      title: 'Mantenimiento Informático Proactivo',
      description: 'Nos anticipamos a los problemas. Con nuestro plan de mantenimiento, tus equipos estarán siempre actualizados, optimizados y seguros. Evita interrupciones costosas y garantiza la continuidad de tu trabajo diario.',
      icon: FiIcons.FiTool,
      path: '/servicios/mantenimiento'
    },
    {
      title: 'Ciberseguridad y Protección de Datos',
      description: 'Tu información es tu activo más valioso. Implementamos barreras de seguridad robustas, desde antivirus gestionado hasta copias de seguridad automáticas, para protegerte contra ransomware, phishing y otras amenazas digitales.',
      icon: FiIcons.FiShield,
      path: '/servicios/ciberseguridad'
    },
    {
      title: 'Inteligencia Artificial para Empresas',
      description: 'Potencia tu negocio con las últimas tecnologías de IA. Implementamos soluciones de machine learning, chatbots inteligentes y análisis predictivo que automatizan procesos y generan insights valiosos para tu negocio.',
      icon: FiIcons.FiBrain,
      path: '/servicios/ia'
    },
    {
      title: 'Soporte Técnico Rápido y Eficaz',
      description: '¿Un ordenador lento o un error inesperado? Nuestro equipo de soporte remoto y presencial está listo para resolver cualquier incidencia de forma ágil, minimizando el tiempo de inactividad para que puedas seguir siendo productivo.',
      icon: FiIcons.FiCpu,
      path: '/servicios/soporte'
    },
    {
      title: 'Venta y Asesoramiento de Equipos',
      description: 'No inviertas a ciegas. Te asesoramos para que adquieras los equipos (ordenadores, servidores, redes) que tu empresa realmente necesita, optimizando tu presupuesto y asegurando el mejor rendimiento a largo plazo.',
      icon: FiIcons.FiMonitor,
      path: '/servicios/hardware'
    },
    {
      title: 'Diseño y Desarrollo Web Profesional',
      description: 'Tu página web es tu mejor comercial. Creamos sitios web modernos, rápidos y seguros que no solo se ven bien en cualquier dispositivo, sino que están diseñados para atraer clientes y cumplir tus objetivos de negocio.',
      icon: FiIcons.FiCloud,
      path: '/servicios/cloud'
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">
          Nuestros Servicios Informáticos
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesList.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg p-8">
              <SafeIcon icon={service.icon} className="h-12 w-12 text-blue-600 mb-4" />
              <h2 className="text-2xl font-semibold mb-4">{service.title}</h2>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <Link to={service.path} className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                Más información
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;